<template>
  <div>
    <div class="clearfix">
      <div class="page-title float-left">자가진단 결과보기</div>
      <div class="float-right"><mdb-btn icon="undo" class="py-2" @click="$router.back()">돌아가기</mdb-btn></div>
    </div>
    <div v-for="(u,ux) in units" :key="ux">
      <div class="title">{{u.name}}/{{u.code}}</div>
      <mdb-tbl sm>
        <mdb-tbl-head>
          <tr class="title">
            <th class="bolder">수행준거</th>
            <th class="text-center bolder" style="width:80px">예</th>
            <th class="text-center bolder" style="width:80px">아니오</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-for="(c,ix) in u.content" :key="ix">
            <td>{{c}}</td>
            <td class="text-center">
              <mdb-icon v-if="answer.units && answer.units[ux].answer[ix]" far icon="circle"/>
            </td>
            <td class="text-center">
              <mdb-icon v-if="answer.units && !answer.units[ux].answer[ix]" far icon="circle"/>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>
    <div class="clearfix">
      <div class="title float-left"></div>
      <div class="float-right"><mdb-btn icon="undo" class="py-2" @click="$router.back()">돌아가기</mdb-btn></div>
    </div>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  name: 'StudentSelfTestView',
  computed: {
    ...mapGetters('auth', ['profileId']),
    ...mapGetters('training', ['lecture']),
    units () {
      return this.lecture(this.$route.query) ? this.lecture(this.$route.query).units : []
    }
  },
  data: () => ({
    answer: {}
  }),
  methods: {
    async load () {
      if (!this.profileId) return
      const student = this.profileId
      const code = this.$route.query.code
      this.answer = await this.$getSelfTestAnswer({ student, code })
    }
  },
  created () {
    this.load()
  },
  watch: {
    profileId () {
      this.load()
    }
  }
}
</script>
